import { ReactNode } from 'react';

export const InputLabel = ({ label }: { label: ReactNode }) => {
  return label ? (
    <div className="font-semibold whitespace-nowrap mb-1">{label}</div>
  ) : null;
};
